import bootstrap from 'bootstrap'
import { domReady } from '@roots/sage/client';
import './common';

/**
 * app.main
 */
const main = async (err) => {
  if (err) {
    // handle hmr errors
    console.error(err);
  }

  // application code
  // MOBILE NAVIGATION
  let fullmenuButton = document.querySelector('.hamburger-wrap');
  let fullmenu = document.querySelector('#fullmenu');

  fullmenuButton.addEventListener('click', function () {
    if (this.classList.contains('active')) {
      this.classList.remove('active');
      fullmenu.classList.remove('open');
    } else {
      this.classList.add('active');
      fullmenu.classList.add('open');
    }
  });


  // MOBILE SUBMENU
  let menuItems = document.querySelectorAll('#fullmenu li.menu-item-has-children > a');

  for (let x = 0; x < menuItems.length; x++) {
    menuItems[x].addEventListener('click', (e) => {
      e.preventDefault();

      if (menuItems[x].parentElement.classList.contains('open')) {
        menuItems[x].parentElement.classList.remove('open');
      } else {

        menuItems[x].parentElement.classList.add('open');
      }
    });
  }
};

/**
 * Initialize
 *
 * @see https://webpack.js.org/api/hot-module-replacement
 */
domReady(main);
import.meta.webpackHot?.accept(main);
